import './layout.scss';
import Sidebar from './Sidebar';
import TopBar from './TopBar';
import ContentLayout from './ContentLayout';

import { useContext } from "react";
import { LayoutContext } from "../../context/LayoutContext";
import { classNames } from 'primereact/utils';
import { useTabViewBorderRadius } from '../../hook/useTabViewBorderRadius';


const MainLayout = () => {

  const { sidebarCollapsed, isMobile } = useContext(LayoutContext);
  
  // Globalny hook do obsługi border-radius dla TabView
  useTabViewBorderRadius();

  return (
    <div className='main-layout'>
      <div className='sidebar-wrapper'>
        <Sidebar />
      </div>
      <div className='top-bar-wrapper'>
        <TopBar />
        <div className={classNames('content-wrapper-scrolled', {'menu-collapsed': sidebarCollapsed || isMobile})} >
          <div className={classNames('content-wrapper', {'menu-collapsed': sidebarCollapsed || isMobile})}>
            <div className={classNames('content', {'menu-collapsed': sidebarCollapsed || isMobile})}>
              <ContentLayout />
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}

export default MainLayout;